import * as React from "react";
import classNames from "classnames";
import { omit } from "lodash";
import { Result } from "antd";
import { ResultProps } from "antd/es/result/index";

type CenterResultProps = ResultProps & {
  whitelabel?: boolean;
};

export const CenterResult: React.FC<CenterResultProps> = (props) => {
  const { whitelabel } = props;
  const spinProps = omit(props, ["whitelabel"]);

  const classes = classNames("verticalCenterWrapper", {
    whitelabel: whitelabel,
  });

  return (
    <div className={classes}>
      <Result {...spinProps} />
    </div>
  );
};
